import React, { forwardRef, memo, useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { permissionsSelector, warehousesHasRoleSelector } from 'app-redux/selectors'
import { getTransTypeUri } from '@/utils/transTypeUri'

const isNewTabClick = (e) => e.metaKey || e.ctrlKey

const LinkTransType = forwardRef(
  (
    {
      title,
      transTypeId,
      data,
      isCashBank = false,
      force,
      suffixUrl,
      recursive,
      permission, // untuk override permission
      onClick,
      ...props
    },
    ref,
  ) => {
    const permissions = useSelector(permissionsSelector)
    const warehousesHasRole = useSelector(warehousesHasRoleSelector)
    const uri = useMemo(
      () =>
        getTransTypeUri(transTypeId, data, permissions, isCashBank, force, {
          warehouses_has_role: warehousesHasRole,
          permissions,
          suffixUrl,
          recursive,
          permission,
          ...props,
        }),
      [
        transTypeId,
        data,
        permissions,
        isCashBank,
        force,
        warehousesHasRole,
        suffixUrl,
        recursive,
        props,
        permission,
      ],
    )

    // Cmd/Ctrl + klik dilepas ke browser supaya buka tab baru. stopPropagation menahan
    // onRow.onClick di Table antd yang kalau tidak, ikut navigasi di tab yang sama.
    const handleClick = useCallback(
      (e) => {
        if (isNewTabClick(e)) {
          e.stopPropagation()
          return
        }

        onClick?.(e)
      },
      [onClick],
    )

    let currentTitle = title

    if (typeof title === 'function') {
      currentTitle = title()
    }

    if (uri === '') {
      return <span>{currentTitle}</span>
    }

    return (
      <Link className="text-primary" ref={ref} to={uri} {...props} onClick={handleClick}>
        {currentTitle}
      </Link>
    )
  },
)

export default memo(LinkTransType)
